import React, { useEffect, useState } from 'react';
import api from '../../api';
import TrainerLayout from './TrainerLayout';

// Eigene Stunden je Quartal (nur die Person, die mit dem Login verknüpft ist)
function aktuellesQuartal() {
  const [y, m] = new Date().toLocaleDateString('sv-SE').split('-').map(Number);
  return { jahr: y, quartal: Math.floor((m - 1) / 3) + 1 };
}
const zahl = (x) => Number(x || 0).toLocaleString('de-DE', { maximumFractionDigits: 2 });
const datum = (iso) => new Date(`${iso}T12:00:00Z`).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });

export default function TrainerStunden() {
  const [q, setQ] = useState(aktuellesQuartal);
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    setDaten(null); setFehler('');
    api.get('/api/trainer/stunden', { params: q })
      .then(r => setDaten(r.data))
      .catch(() => setFehler('Stunden konnten nicht geladen werden'));
  }, [q]);

  const schritt = (d) => setQ(({ jahr, quartal }) => {
    const n = quartal + d;
    return n < 1 ? { jahr: jahr - 1, quartal: 4 } : n > 4 ? { jahr: jahr + 1, quartal: 1 } : { jahr, quartal: n };
  });
  const istAktuell = q.jahr === aktuellesQuartal().jahr && q.quartal === aktuellesQuartal().quartal;
  const pfeil = { background: '#fff', border: '1px solid #ddd', borderRadius: 8, width: 44, height: 40, fontSize: '1.1rem', cursor: 'pointer' };

  return (
    <TrainerLayout title="Meine Stunden" backTo="/trainer/gruppen">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.875rem' }}>
        <button style={pfeil} onClick={() => schritt(-1)} aria-label="Vorheriges Quartal">‹</button>
        <div style={{ flex: 1, textAlign: 'center', fontWeight: 700 }}>Q{q.quartal} {q.jahr}{istAktuell ? ' (aktuell)' : ''}</div>
        <button style={pfeil} onClick={() => schritt(1)} disabled={istAktuell} aria-label="Nächstes Quartal">›</button>
      </div>

      {fehler && <div className="alert alert-error">{fehler}</div>}
      {!daten && !fehler && <div style={{ textAlign: 'center', padding: '2rem' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div>}

      {daten && !daten.verknuepft && (
        <div style={{ background: '#fff', borderRadius: 12, padding: '1rem', color: '#555' }}>
          Dein Login ist noch keiner Person im Team zugeordnet. Bitte wende dich an den Schwimmadmin.
        </div>
      )}

      {daten?.verknuepft && (
        <>
          <div style={{ background: '#1565c0', color: '#fff', borderRadius: 12, padding: '1rem', marginBottom: '0.875rem', textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', fontWeight: 800 }}>{zahl(daten.stunden)} Std.</div>
            <div style={{ opacity: 0.9, fontSize: '0.85rem' }}>{daten.anzahl} Einsätze{daten.abgeschlossen ? ' · 🔒 abgeschlossen' : ' · vorläufig'}</div>
          </div>
          {daten.gruppen.length > 0 && (
            <div style={{ background: '#fff', borderRadius: 12, padding: '0.75rem 1rem', marginBottom: '0.875rem', fontSize: '0.88rem' }}>
              {daten.gruppen.map(g => (
                <div key={g.gruppe_id} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0' }}>
                  <span>{g.gruppe}</span><strong>{zahl(g.stunden)} Std.</strong>
                </div>
              ))}
            </div>
          )}
          <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden' }}>
            {daten.einsaetze.length === 0 && <div style={{ padding: '1rem', color: '#999' }}>Keine Einsätze in diesem Quartal</div>}
            {daten.einsaetze.map(e => (
              <div key={e.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.65rem 1rem', borderBottom: '1px solid #f3f3f3', fontSize: '0.88rem' }}>
                <span><strong>{datum(e.datum)}</strong> · {e.gruppe_name}<span style={{ color: '#888' }}> · {e.von}–{e.bis}</span></span>
                <span>{zahl(e.stunden)}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </TrainerLayout>
  );
}
